import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IClientLogo } from "../clientLogoModel";

export const getAllClientLogos = createAsyncThunk(
  "ClientLogo/FindAllClientLogo",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/FindAllClientLogo`,
        {
          ClientName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Client Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createClientLogo = createAsyncThunk(
  "ClientLogo/InsertClientLogo",
  async (ClientLogoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/InsertClientLogo`,
        ClientLogoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating client logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateClientLogo = createAsyncThunk(
  "ClientLogo/UpdateClientLogo",
  async (ClientLogoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/UpdateClientLogo`,
        ClientLogoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating client logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteClientLogo = createAsyncThunk(
  "ClientLogo/DeleteClientLogo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/DeleteClientLogo`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting client logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getClientLogoByID = createAsyncThunk(
  "ClientLogo/FindByIDClientLogo",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/FindByIDClientLogo`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ClientName: result?.ClientName,
        Image: result?.image,
        IsActive: result.IsActive ? 1 : 2,
      } as IClientLogo;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching client logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveClientLogos = createAsyncThunk(
  "ClientLogo/FindAllActiveClientLogo",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ClientLogo/FindAllActiveClientLogo`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Client Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveClientLogo = createAsyncThunk(
  "ClientLogo/ActiveInActiveClientLogo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/ActiveInActiveClientLogo`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive client logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ClientLogoImageUpload = createAsyncThunk(
  "ClientLogo/ClientLogoImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ClientLogo/ClientLogoImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload client logo Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
